import React from 'react'
import {Dropdown} from 'react-bootstrap'

interface Language {
  code: string
  name: string
  nativeName: string
  isDefault: boolean
}

interface Props {
  languages: Language[]
  currentLang: string
  onChange: (lang: string) => void
  availableLanguages?: string[]
}

const HelpLanguageSelector: React.FC<Props> = ({
  languages,
  currentLang,
  onChange,
  availableLanguages,
}) => {
  const current = languages.find((l) => l.code === currentLang)

  return (
    <Dropdown>
      <Dropdown.Toggle
        variant='light'
        size='sm'
        className='help-language-badge'
        aria-label={`Language: ${current?.name || currentLang}. Click to change.`}
      >
        {current?.nativeName || currentLang.toUpperCase()}
      </Dropdown.Toggle>
      <Dropdown.Menu>
        {languages.map((lang) => {
          const isAvailable = !availableLanguages || availableLanguages.includes(lang.code)
          return (
            <Dropdown.Item
              key={lang.code}
              active={lang.code === currentLang}
              disabled={!isAvailable}
              onClick={() => isAvailable && onChange(lang.code)}
            >
              <span>{lang.nativeName}</span>
              <span className='text-muted ms-1'>({lang.name})</span>
              {!isAvailable && (
                <span className='badge badge-light-secondary badge-sm ms-2 help-lang-unavailable'>
                  Coming soon
                </span>
              )}
            </Dropdown.Item>
          )
        })}
      </Dropdown.Menu>
    </Dropdown>
  )
}

export {HelpLanguageSelector}
